module.exports = __webpack_public_path__ + "img/img0402.4e089204.png";